var N = Object.defineProperty;
var P = (n, r, e) => r in n ? N(n, r, { enumerable: !0, configurable: !0, writable: !0, value: e }) : n[r] = e;
var x = (n, r, e) => (P(n, typeof r != "symbol" ? r + "" : r, e), e);
import { j as o } from "./jsx-runtime-721af1ab.js";
import { Box as g, Button as E, Text as j, Link as V } from "@chakra-ui/react";
import * as L from "react";
import { useState as A, useEffect as B } from "react";
import { as as O, at as M, l as D, au as q, c as b } from "./eMyAsurionProvider-4128cec8.js";
import "@tanstack/react-query";
import "./useAccount-9a3d6a50.js";
import "./myasurion-shared.mixpanel.es.js";
import "@chakra-ui/icons";
import "./FeatureProvider-eea49aec.js";
import "./TranslationContext-f3729120.js";
import "framer-motion";
import "./cleave-react-node-c095712c.js";
import "./lodash-3345fe65.js";
import "./FileSaver.min-1b3caba2.js";
import "@react-oauth/google";
import "react-router-dom";
import "./chunk-KRPLQIP4-1ae0870d.js";
import "@emotion/react";
import "@emotion/styled";
import "./useContentfulImage-2de5e9b4.js";
import "./domains-6461a203.js";
import "./contentful-c6e0c83f.js";
import "./MobileView-1a8aba0d.js";
import "./ProfileIcon-ce0111a3.js";
import "./myasurion-shared.widgets.es.js";
import "./myasurion-shared.profile.es.js";
import "./myasurion-shared.colors.es.js";
import "./myasurion-shared.carrier.es.js";
import "mixpanel-browser";
const { useState: z, useEffect: F } = L, K = ({
  src: n = "",
  showPlayer: r = !0,
  minHeight: e = "70vh",
  width: t = "full"
}) => {
  const [s, a] = z(window.matchMedia("(min-width: 1024px)").matches);
  return F(() => {
    window.matchMedia("(min-width: 1024px)").addEventListener("change", (l) => a(l.matches));
  }, []), /* @__PURE__ */ o.jsx(g, { display: `${r ? "block" : "none"}`, children: /* @__PURE__ */ o.jsx(
    "video",
    {
      style: {
        minHeight: s ? "320px" : e,
        objectFit: "cover",
        margin: "auto",
        width: s ? "full" : t
      },
      controls: !0,
      autoPlay: !1,
      src: n,
      playsInline: !0,
      preload: "none"
    }
  ) });
}, J = (n) => {
  const r = /* @__PURE__ */ new Date();
  if (n <= r)
    return "00:00";
  let e = Math.round(n.getSeconds() - r.getSeconds()), t = Math.round(n.getMinutes() - r.getMinutes());
  return e < 0 && (e = 60 + e, t = t - 1), t < 0 && (t = 60 + t), `${t.toString().padStart(2, "0")}:${e.toString().padStart(2, "0")}`;
}, Q = ({ timer: n, parentCallback: r }) => {
  const [e, t] = A("02:00");
  return B(() => {
    if (n >= /* @__PURE__ */ new Date()) {
      const s = setInterval(() => {
        const a = J(n);
        t(a), r(a);
      }, 1e3);
      return () => clearInterval(s);
    }
  }, [n, e]), /* @__PURE__ */ o.jsx("div", { children: /* @__PURE__ */ o.jsx("span", { children: e }) });
};
var v;
let G = (v = class extends L.Component {
  constructor(e) {
    super(e);
    x(this, "canvas", null);
    x(this, "ctx", null);
    x(this, "requestUserMediaId", 0);
    x(this, "unmounted", !1);
    x(this, "stream", null);
    x(this, "video", null);
    this.state = {
      hasUserMedia: !1
    };
  }
  componentDidMount() {
    const { state: e, props: t } = this;
    if (this.unmounted = !1, console.log("componentDidMount"), !O()) {
      t.onUserMediaError("getUserMedia not supported"), console.log("componentDidMount : getUserMedia not supported");
      return;
    }
    e.hasUserMedia || this.requestUserMedia(), t.children && typeof t.children != "function" && (console.warn("children must be a function"), console.log("componentDidMount : children must be a function"));
  }
  componentDidUpdate(e) {
    const { props: t } = this;
    if (console.log("componentDidUpdate"), !O()) {
      t.onUserMediaError("getUserMedia not supported"), console.log("getUserMedia not supported");
      return;
    }
    const s = JSON.stringify(e.audioConstraints) !== JSON.stringify(t.audioConstraints), a = JSON.stringify(e.videoConstraints) !== JSON.stringify(t.videoConstraints), l = e.minScreenshotWidth !== t.minScreenshotWidth, p = e.minScreenshotHeight !== t.minScreenshotHeight;
    (a || l || p) && (this.canvas = null, this.ctx = null), (s || a) && (console.log("stopAndCleanup from componentDidUpdate"), this.stopAndCleanup(), this.requestUserMedia());
  }
  componentWillUnmount() {
    console.log("componentWillUnmount"), console.log("stopAndCleanup from componentWillUnmount"), this.unmounted = !0, this.stopAndCleanup();
  }
  static stopMediaStream(e) {
    console.log("stopMediaStream"), console.log(" stream at stopMediaStream", e), e && (console.log("inside stream"), console.log(
      "inside stream stream.getVideoTracks ?? stream.getVideoTracks ??",
      e.getVideoTracks,
      e.getAudioTracks
    ), e.getVideoTracks && e.getAudioTracks ? (console.log("stream has audio video tracks"), e.getVideoTracks().map((t) => {
      console.log("video track", t), e.removeTrack(t), t.stop();
    }), e.getAudioTracks().map((t) => {
      console.log("audio track", t), e.removeTrack(t), t.stop();
    })) : (console.log("calling stream.stop function"), e.stop()));
  }
  stopAndCleanup() {
    const { state: e } = this;
    console.log("stopAndCleanup"), console.log("hasUserMedia ", e.hasUserMedia), e.hasUserMedia && (v.stopMediaStream(this.stream), e.src && window.URL.revokeObjectURL(e.src));
  }
  getScreenshot(e) {
    const { state: t, props: s } = this;
    if (!t.hasUserMedia)
      return null;
    const a = this.getCanvas(e);
    return a && a.toDataURL(s.screenshotFormat, s.screenshotQuality);
  }
  getCanvas(e) {
    const { state: t, props: s } = this;
    if (!this.video)
      return console.log("getCanvas this.video", !this.video), null;
    if (!t.hasUserMedia || !this.video.videoHeight)
      return console.log(
        "getCanvas !state.hasUserMedia || !this.video.videoHeight",
        !t.hasUserMedia + "  |  " + !this.video.videoHeight
      ), null;
    if (!this.ctx) {
      let p = this.video.videoWidth, c = this.video.videoHeight;
      if (!this.props.forceScreenshotSourceSize) {
        const d = p / c;
        p = s.minScreenshotWidth || this.video.clientWidth, c = p / d, s.minScreenshotHeight && c < s.minScreenshotHeight && (c = s.minScreenshotHeight, p = c * d);
      }
      this.canvas = document.createElement("canvas"), this.canvas.width = (e == null ? void 0 : e.width) || p, this.canvas.height = (e == null ? void 0 : e.height) || c, this.ctx = this.canvas.getContext("2d");
    }
    const { ctx: a, canvas: l } = this;
    return a && l && (s.mirrored && (a.translate(l.width, 0), a.scale(-1, 1)), a.imageSmoothingEnabled = s.imageSmoothing, a.drawImage(
      this.video,
      0,
      0,
      (e == null ? void 0 : e.width) || l.width,
      (e == null ? void 0 : e.height) || l.height
    ), s.mirrored && (a.scale(-1, 1), a.translate(-l.width, 0))), console.log("getCanvas return canvas", l), l;
  }
  requestUserMedia() {
    (() => {
      this.requestUserMediaId++;
      const t = this.requestUserMediaId;
      navigator.mediaDevices.getUserMedia({
        video: !0,
        audio: !0
      }).then((s) => {
        console.log("streams are", s), this.unmounted || t !== this.requestUserMediaId ? v.stopMediaStream(s) : this.handleUserMedia(null, s);
      }).catch((s) => {
        console.log("error before handle user media", s), this.handleUserMedia(s);
      });
    })();
  }
  handleUserMedia(e, t) {
    const { props: s } = this;
    if (console.log("handleUserMedia"), e || !t) {
      this.setState({ hasUserMedia: !1 }), s.onUserMediaError(e);
      return;
    }
    this.stream = t, console.log("has Video", this.video);
    try {
      this.video && (this.video.srcObject = t), console.log("setting handleUserMedia True"), this.setState({ hasUserMedia: !0 });
    } catch (a) {
      console.log("handleUserMedia catch", a), this.setState({
        hasUserMedia: !0,
        src: window.URL.createObjectURL(t)
      });
    }
    console.log("handleUserMedia before onUserMedia", t), s.onUserMedia(t);
  }
  render() {
    const { state: e, props: t } = this, {
      audio: s,
      muted: a,
      forceScreenshotSourceSize: l,
      onUserMedia: p,
      onUserMediaError: c,
      screenshotFormat: d,
      screenshotQuality: m,
      minScreenshotWidth: u,
      minScreenshotHeight: y,
      audioConstraints: C,
      videoConstraints: h,
      imageSmoothing: T,
      mirrored: w,
      style: f = {},
      children: R,
      ...k
    } = t;
    return w && { ...f, transform: `${f.transform || ""}` }, this.getScreenshot.bind(this), /* @__PURE__ */ o.jsx(o.Fragment, { children: /* @__PURE__ */ o.jsx(
      "video",
      {
        autoPlay: !0,
        src: e.src,
        muted: a,
        playsInline: !0,
        ref: (U) => {
          this.video = U;
        },
        style: {
          minHeight: "53vh",
          objectFit: "cover",
          margin: "auto",
          width: "full"
        }
      }
    ) });
  }
}, x(v, "defaultProps", {
  audio: !1,
  muted: !1,
  forceScreenshotSourceSize: !1,
  imageSmoothing: !0,
  mirrored: !0,
  onUserMedia: () => {
  },
  onUserMediaError: () => {
  },
  screenshotFormat: "image/webp",
  screenshotQuality: 0.92
}), v);
const { useState: W, useEffect: H, useCallback: $, useRef: I } = L, X = ({
  showWebcam: n,
  capture: r,
  setSrc: e,
  setBlob: t,
  setCapturing: s
}) => {
  const a = /* @__PURE__ */ new Date(), [l, p] = W(a), c = I({}), d = I({}), [m, u] = W([]), [y, C] = W(window.matchMedia("(min-width: 768px)").matches);
  H(() => {
    window.matchMedia("(min-width: 768px)").addEventListener("change", (i) => C(i.matches));
  }, []);
  const h = (i) => {
    i === "00:00" && s("STOP");
  }, T = $(() => {
    console.log("mimeType:", M()), console.log("isMediaSupported:", MediaRecorder.isTypeSupported(M())), console.log("webcamRef is", c), console.log("webcamRef stream is", c.current.stream), d.current = new MediaRecorder(c.current.stream, {
      mimeType: MediaRecorder.isTypeSupported(M()) === !0 ? M() : "video/webm"
    }), d.current.addEventListener("dataavailable", f), d.current.addEventListener("stop", U), d.current.start(1e3);
  }, [c, s, d]), w = $(() => {
    if (d.current.state === "inactive")
      return d.current.stop();
    p(/* @__PURE__ */ new Date("02:00"));
  }, [d, c, s]), f = $(
    (i) => {
      console.log("handleDataAvailable", "Called", i), console.log("handleDataAvailable data", i == null ? void 0 : i.data), console.log("handleDataAvailable data size", i == null ? void 0 : i.data.size), (i == null ? void 0 : i.data.size) > 0 && u((S) => S.concat(i == null ? void 0 : i.data));
    },
    [u]
  ), R = () => {
    console.log("handleStartCaptureClick"), T(), a.setMinutes(a.getMinutes() + 2), p(a);
  }, k = (i) => {
    console.log("onUserMediaError", i);
  };
  H(() => {
    if (m.length) {
      const i = new Blob(m, {
        type: MediaRecorder.isTypeSupported(M()) === !0 ? M() : "video/webm"
      });
      console.log("BLOB is", i), t(i);
      const S = URL.createObjectURL(i);
      console.log("URL is", S), e(S);
    }
  }, [m]), H(() => {
    r === "STOP" ? w() : r === "START" && u([]);
  }, [r]);
  const U = (i) => {
    console.log("data available after MediaRecorder.stop() called."), console.log("data available after MediaRecorder.stop() called.", i), console.log("recorder stopped");
  };
  return /* @__PURE__ */ o.jsx(o.Fragment, { children: n && /* @__PURE__ */ o.jsxs("div", { className: "text-center", children: [
    /* @__PURE__ */ o.jsx("div", { className: y ? "" : "webcam-container", children: /* @__PURE__ */ o.jsx(
      G,
      {
        audio: !0,
        muted: !0,
        autoPlay: !0,
        ref: c,
        onUserMedia: R,
        onUserMediaError: k,
        mirrored: !0
      }
    ) }),
    /* @__PURE__ */ o.jsx(
      "div",
      {
        style: { display: "flex", justifyContent: "end" },
        className: y ? "" : "timer-overlay",
        children: /* @__PURE__ */ o.jsx(
          "div",
          {
            style: {
              background: "black",
              color: "white",
              display: "inline-block",
              paddingInline: "5px"
            },
            children: /* @__PURE__ */ o.jsx(
              Q,
              {
                parentCallback: (i) => h(i),
                timer: l
              }
            )
          }
        )
      }
    )
  ] }) });
}, Te = ({
  handleSubmit: n,
  CarouselbtnLable: r,
  carouselContent: e,
  uploadStatus: t,
  handleNextClick: s
}) => {
  const [a, l] = A(""), [p, c] = A(new Blob([""])), [d, m] = A("START"), u = "VideoDeclaration", { data: y } = D(), { theme: C } = y, { colors: h } = C, T = (i) => {
    c(i);
  }, w = (i) => {
    l(i);
  }, f = (i) => {
    m(i);
  }, R = () => {
    m("START");
  }, k = () => {
    m("STOP");
  }, U = (i) => i == null ? void 0 : i.map((S) => /* @__PURE__ */ o.jsxs(g, { pb: "2rem", children: [
    /* @__PURE__ */ o.jsx(j, { textAlign: "justify", children: S.headerText }),
    /* @__PURE__ */ o.jsx(
      j,
      {
        textColor: "#008662",
        paddingTop: "0.5rem",
        textAlign: "left",
        fontSize: "18px",
        children: S.bodyText
      }
    )
  ] }));
  return /* @__PURE__ */ o.jsxs("div", { style: { position: "relative", minHeight: "100vh" }, children: [
    /* @__PURE__ */ o.jsx(
      X,
      {
        capture: d,
        showWebcam: d === "START",
        setSrc: w,
        setBlob: T,
        setCapturing: f
      }
    ),
    /* @__PURE__ */ o.jsx(K, { showPlayer: d === "STOP", src: a }),
    /* @__PURE__ */ o.jsxs(
      g,
      {
        style: {
          position: "absolute",
          bottom: 0,
          left: 0,
          width: "100%"
        },
        children: [
          d === "START" && t === "NONE" && /* @__PURE__ */ o.jsxs(
            g,
            {
              bg: "white",
              maxHeight: "285px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ o.jsx(
                  q.Carousel,
                  {
                    showArrows: !1,
                    showStatus: !1,
                    autoPlay: !0,
                    interval: 1e4,
                    children: U(e)
                  }
                ),
                /* @__PURE__ */ o.jsx(g, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ o.jsx(
                  E,
                  {
                    variant: "outline",
                    onClick: () => {
                      k();
                    },
                    bg: h == null ? void 0 : h.primary,
                    textColor: "white",
                    width: { base: "full", lg: "50%" },
                    mb: "0.5rem",
                    children: /* @__PURE__ */ o.jsx(
                      b,
                      {
                        text: r,
                        translationKey: `${u}/CarouselbtnLable`
                      }
                    )
                  }
                ) })
              ]
            }
          ),
          d !== "START" && t === "NONE" && /* @__PURE__ */ o.jsxs(
            g,
            {
              bg: "white",
              maxHeight: "245px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ o.jsx(j, { fontWeight: 700, children: "Press play to review your video" }),
                /* @__PURE__ */ o.jsx(g, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ o.jsx(
                  E,
                  {
                    variant: "outline",
                    onClick: () => {
                      n(p);
                    },
                    bg: h == null ? void 0 : h.primary,
                    textColor: "white",
                    width: { base: "full", lg: "50%" },
                    mt: "1rem",
                    children: /* @__PURE__ */ o.jsx(
                      b,
                      {
                        text: "Submit video declaration",
                        translationKey: `${u}/btnSubmit`
                      }
                    )
                  }
                ) }),
                /* @__PURE__ */ o.jsx(g, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ o.jsx(
                  V,
                  {
                    color: h == null ? void 0 : h.accent,
                    marginTop: "20px",
                    textDecoration: "underline",
                    onClick: () => R(),
                    fontWeight: 700,
                    children: /* @__PURE__ */ o.jsx(
                      b,
                      {
                        text: "Re-take video",
                        translationKey: `${u}/btnRetake`
                      }
                    )
                  }
                ) })
              ]
            }
          ),
          t === "INPROGRESS" && /* @__PURE__ */ o.jsxs(
            g,
            {
              bg: "white",
              maxHeight: "245px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ o.jsx(j, { fontWeight: 700, children: /* @__PURE__ */ o.jsx(
                  b,
                  {
                    text: "Please wait while we upload your video...",
                    translationKey: `${u}/labelPleaseWait`
                  }
                ) }),
                /* @__PURE__ */ o.jsx(g, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ o.jsx(
                  E,
                  {
                    isLoading: !0,
                    loadingText: "Uploading video...",
                    colorScheme: "primary",
                    variant: "outline",
                    width: { base: "full", lg: "50%" },
                    mt: "1rem",
                    children: /* @__PURE__ */ o.jsx(
                      b,
                      {
                        text: "Uploading video...",
                        translationKey: `${u}/labelUploadingVideo`
                      }
                    )
                  }
                ) })
              ]
            }
          ),
          t === "COMPLETED" && /* @__PURE__ */ o.jsxs(
            g,
            {
              bg: "white",
              maxHeight: "245px",
              style: {
                boxShadow: "0px -4px 4px 0px rgba(0, 0, 0, 0.08)",
                borderRadius: "13px 13px 0px 0px",
                marginTop: "auto"
              },
              p: "1rem",
              children: [
                /* @__PURE__ */ o.jsx(j, { fontWeight: 700, children: /* @__PURE__ */ o.jsx(
                  b,
                  {
                    text: "Your video declaration is submitted!",
                    translationKey: `${u}/labelVideoSubmitted`
                  }
                ) }),
                /* @__PURE__ */ o.jsx(g, { display: "flex", justifyContent: "center", children: /* @__PURE__ */ o.jsx(
                  E,
                  {
                    variant: "outline",
                    onClick: () => {
                      s();
                    },
                    bg: h == null ? void 0 : h.primary,
                    textColor: "white",
                    width: { base: "full", lg: "50%" },
                    mt: "1rem",
                    children: /* @__PURE__ */ o.jsx(
                      b,
                      {
                        text: "Next",
                        translationKey: `${u}/nextButtonText`
                      }
                    )
                  }
                ) })
              ]
            }
          )
        ]
      }
    )
  ] });
};
export {
  Te as VideoDeclaration,
  K as VideoPlayer
};
